/**
 * Plain-language status for a shared tablet on the Tablets page (OPEN-036 / DEC-335).
 *
 * Times are RELATIVE ("2h ago"), so no clock or time zone is ever shown (DEC-004).
 */

import { formatAge } from '../stuck-jobs/stuck-jobs-format';
import type { SharedDeviceRow } from './use-shared-devices';

/** "Last seen" cell: who was on it, and when the tablet last reached the server. */
export function lastSeenText(row: SharedDeviceRow, nowMs: number): string {
  if (row.lastSeenAt === null) return 'Not connected since this feature was added';
  const age = formatAge(row.lastSeenAt, nowMs);
  return row.lastDriverName !== null ? `${row.lastDriverName}, ${age}` : age;
}

/** Status cell. null when there is nothing to say. */
export function clearStatusText(row: SharedDeviceRow, nowMs: number): string | null {
  if (row.clearPending && row.clearRequestedAt !== null) {
    return `Sign-out requested ${formatAge(row.clearRequestedAt, nowMs)}. Waiting for the tablet to connect.`;
  }
  if (row.clearHonoredAt !== null) {
    return `Signed out ${formatAge(row.clearHonoredAt, nowMs)}`;
  }
  return null;
}
